// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_67W","cls2":"Header-cls2_67n Header-cls1_67W"};